export interface Stock {
  id: string;
  name: string;
  symbol: string;
  exchange: string;
  type: 'stock' | 'etf' | 'fund';
  sector?: string;
  popular?: boolean;
}

// Curated list of PEA-eligible stocks (CAC 40, Euro Stoxx, popular ETFs)
export const PEA_STOCKS: Stock[] = [
  // CAC 40 - Most popular
  {
    id: 'totalenergies',
    name: 'TotalEnergies',
    symbol: 'TTE.PA',
    exchange: 'Euronext Paris',
    type: 'stock',
    sector: 'energy',
    popular: true,
  },
  {
    id: 'lvmh',
    name: 'LVMH',
    symbol: 'MC.PA',
    exchange: 'Euronext Paris',
    type: 'stock',
    sector: 'luxury',
    popular: true,
  },
  {
    id: 'sanofi',
    name: 'Sanofi',
    symbol: 'SAN.PA',
    exchange: 'Euronext Paris',
    type: 'stock',
    sector: 'healthcare',
    popular: true,
  },
  {
    id: 'airbus',
    name: 'Airbus',
    symbol: 'AIR.PA',
    exchange: 'Euronext Paris',
    type: 'stock',
    sector: 'industrials',
    popular: true,
  },
  {
    id: 'air-liquide',
    name: 'Air Liquide',
    symbol: 'AI.PA',
    exchange: 'Euronext Paris',
    type: 'stock',
    sector: 'chemicals',
    popular: true,
  },
  {
    id: 'bnp-paribas',
    name: 'BNP Paribas',
    symbol: 'BNP.PA',
    exchange: 'Euronext Paris',
    type: 'stock',
    sector: 'finance',
    popular: true,
  },
  {
    id: 'schneider-electric',
    name: 'Schneider Electric',
    symbol: 'SU.PA',
    exchange: 'Euronext Paris',
    type: 'stock',
    sector: 'industrials',
    popular: true,
  },
  {
    id: 'loreal',
    name: "L'Oréal",
    symbol: 'OR.PA',
    exchange: 'Euronext Paris',
    type: 'stock',
    sector: 'consumer',
    popular: true,
  },
  {
    id: 'safran',
    name: 'Safran',
    symbol: 'SAF.PA',
    exchange: 'Euronext Paris',
    type: 'stock',
    sector: 'aerospace',
    popular: true,
  },
  {
    id: 'hermes',
    name: 'Hermès',
    symbol: 'RMS.PA',
    exchange: 'Euronext Paris',
    type: 'stock',
    sector: 'luxury',
    popular: true,
  },
  {
    id: 'axa',
    name: 'AXA',
    symbol: 'CS.PA',
    exchange: 'Euronext Paris',
    type: 'stock',
    sector: 'insurance',
    popular: true,
  },
  {
    id: 'saint-gobain',
    name: 'Saint-Gobain',
    symbol: 'SGO.PA',
    exchange: 'Euronext Paris',
    type: 'stock',
    sector: 'materials',
    popular: true,
  },

  // CAC 40 - Others
  {
    id: 'danone',
    name: 'Danone',
    symbol: 'BN.PA',
    exchange: 'Euronext Paris',
    type: 'stock',
    sector: 'consumer',
  },
  {
    id: 'engie',
    name: 'Engie',
    symbol: 'ENGI.PA',
    exchange: 'Euronext Paris',
    type: 'stock',
    sector: 'utilities',
  },
  {
    id: 'vinci',
    name: 'Vinci',
    symbol: 'DG.PA',
    exchange: 'Euronext Paris',
    type: 'stock',
    sector: 'industrials',
  },
  {
    id: 'kering',
    name: 'Kering',
    symbol: 'KER.PA',
    exchange: 'Euronext Paris',
    type: 'stock',
    sector: 'luxury',
  },
  {
    id: 'societe-generale',
    name: 'Société Générale',
    symbol: 'GLE.PA',
    exchange: 'Euronext Paris',
    type: 'stock',
    sector: 'finance',
  },
  {
    id: 'credit-agricole',
    name: 'Crédit Agricole',
    symbol: 'ACA.PA',
    exchange: 'Euronext Paris',
    type: 'stock',
    sector: 'finance',
  },
  {
    id: 'michelin',
    name: 'Michelin',
    symbol: 'ML.PA',
    exchange: 'Euronext Paris',
    type: 'stock',
    sector: 'consumer',
  },
  {
    id: 'stellantis',
    name: 'Stellantis',
    symbol: 'STLAP.PA',
    exchange: 'Euronext Paris',
    type: 'stock',
    sector: 'automotive',
  },
  {
    id: 'renault',
    name: 'Renault',
    symbol: 'RNO.PA',
    exchange: 'Euronext Paris',
    type: 'stock',
    sector: 'automotive',
  },
  {
    id: 'orange',
    name: 'Orange',
    symbol: 'ORA.PA',
    exchange: 'Euronext Paris',
    type: 'stock',
    sector: 'telecom',
  },
  {
    id: 'bouygues',
    name: 'Bouygues',
    symbol: 'EN.PA',
    exchange: 'Euronext Paris',
    type: 'stock',
    sector: 'industrials',
  },
  {
    id: 'pernod-ricard',
    name: 'Pernod Ricard',
    symbol: 'RI.PA',
    exchange: 'Euronext Paris',
    type: 'stock',
    sector: 'consumer',
  },
  {
    id: 'capgemini',
    name: 'Capgemini',
    symbol: 'CAP.PA',
    exchange: 'Euronext Paris',
    type: 'stock',
    sector: 'technology',
  },
  {
    id: 'thales',
    name: 'Thales',
    symbol: 'HO.PA',
    exchange: 'Euronext Paris',
    type: 'stock',
    sector: 'defense',
  },
  {
    id: 'dassault-systemes',
    name: 'Dassault Systèmes',
    symbol: 'DSY.PA',
    exchange: 'Euronext Paris',
    type: 'stock',
    sector: 'technology',
  },
  {
    id: 'legrand',
    name: 'Legrand',
    symbol: 'LR.PA',
    exchange: 'Euronext Paris',
    type: 'stock',
    sector: 'industrials',
  },
  {
    id: 'publicis',
    name: 'Publicis',
    symbol: 'PUB.PA',
    exchange: 'Euronext Paris',
    type: 'stock',
    sector: 'media',
  },
  {
    id: 'essilor-luxottica',
    name: 'EssilorLuxottica',
    symbol: 'EL.PA',
    exchange: 'Euronext Paris',
    type: 'stock',
    sector: 'healthcare',
  },
  {
    id: 'stmicroelectronics',
    name: 'STMicroelectronics',
    symbol: 'STMPA.PA',
    exchange: 'Euronext Paris',
    type: 'stock',
    sector: 'technology',
  },
  {
    id: 'veolia',
    name: 'Veolia',
    symbol: 'VIE.PA',
    exchange: 'Euronext Paris',
    type: 'stock',
    sector: 'utilities',
  },
  {
    id: 'carrefour',
    name: 'Carrefour',
    symbol: 'CA.PA',
    exchange: 'Euronext Paris',
    type: 'stock',
    sector: 'retail',
  },
  {
    id: 'worldline',
    name: 'Worldline',
    symbol: 'WLN.PA',
    exchange: 'Euronext Paris',
    type: 'stock',
    sector: 'technology',
  },
  {
    id: 'teleperformance',
    name: 'Teleperformance',
    symbol: 'TEP.PA',
    exchange: 'Euronext Paris',
    type: 'stock',
    sector: 'services',
  },
  {
    id: 'arcelormittal',
    name: 'ArcelorMittal',
    symbol: 'MT.PA',
    exchange: 'Euronext Paris',
    type: 'stock',
    sector: 'materials',
  },
  {
    id: 'unibail-rodamco',
    name: 'Unibail-Rodamco',
    symbol: 'URW.PA',
    exchange: 'Euronext Paris',
    type: 'stock',
    sector: 'real_estate',
  },
  {
    id: 'eurofins',
    name: 'Eurofins Scientific',
    symbol: 'ERF.PA',
    exchange: 'Euronext Paris',
    type: 'stock',
    sector: 'healthcare',
  },

  // Popular ETFs (PEA-eligible)
  {
    id: 'amundi-msci-world',
    name: 'Amundi MSCI World',
    symbol: 'CW8.PA',
    exchange: 'Euronext Paris',
    type: 'etf',
    popular: true,
  },
  {
    id: 'amundi-sp500',
    name: 'Amundi S&P 500',
    symbol: 'PE500.PA',
    exchange: 'Euronext Paris',
    type: 'etf',
    popular: true,
  },
  {
    id: 'lyxor-cac40',
    name: 'Amundi CAC 40',
    symbol: 'CAC.PA',
    exchange: 'Euronext Paris',
    type: 'etf',
    popular: true,
  },
  {
    id: 'amundi-euro-stoxx50',
    name: 'Amundi Euro Stoxx 50',
    symbol: 'C50.PA',
    exchange: 'Euronext Paris',
    type: 'etf',
  },
  {
    id: 'lyxor-nasdaq',
    name: 'Amundi Nasdaq-100',
    symbol: 'PANX.PA',
    exchange: 'Euronext Paris',
    type: 'etf',
    popular: true,
  },
  {
    id: 'amundi-emerging',
    name: 'Amundi MSCI Emerging Markets',
    symbol: 'PAEEM.PA',
    exchange: 'Euronext Paris',
    type: 'etf',
  },
  {
    id: 'bnp-easy-stoxx600',
    name: 'BNP Easy Stoxx 600',
    symbol: 'ETZ.PA',
    exchange: 'Euronext Paris',
    type: 'etf',
  },
];

export function searchStocks(query: string): Stock[] {
  if (!query || query.length < 1) return [];
  const q = query.toLowerCase();
  return PEA_STOCKS.filter(
    (s) =>
      s.name.toLowerCase().includes(q) ||
      s.symbol.toLowerCase().includes(q) ||
      (s.sector && s.sector.toLowerCase().includes(q)) ||
      s.id.toLowerCase().includes(q)
  ).slice(0, 12);
}

export function getPopularStocks(): Stock[] {
  return PEA_STOCKS.filter((s) => s.popular);
}
